import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
// import OrderableList from "../../OrderableList/OrderableList"

class BuilderOrder extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'order',
      'tab-pane': true 
    })
    return (
      <div className={tabClasses} id='order'>
        {/* <OrderableList
          titleText='order' 
          helperText= 'amenities_order_helper_text'
          onChange= {this.props.onChangeOrder}
          allInputs= {this.props.all_additional_customer_fields}/> */}
      </div>
    )
  }
}

export default BuilderOrder